import { SearchQuestionnairesSurvey } from './SearchQuestionnairesSurvey.component'
import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

const withUnmount = withUnmountTransition(SearchQuestionnairesSurvey)
export { withUnmount as SearchQuestionnairesSurvey }
